import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageApiService } from '@doc/api/server-bo';
import { BehaviorSubject } from 'rxjs'; // Import BehaviorSubject

@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'ar'];
  private languageApiService = inject(LanguageApiService);
  
  // Create a BehaviorSubject to hold the current language
  private currentLanguageSubject = new BehaviorSubject<string>('en');
  public currentLanguage$ = this.currentLanguageSubject.asObservable(); // Expose as observable

  constructor(public translate: TranslateService, private cookieService: CookieService) {
    this.translate.addLangs(this.languages);
    this.getLanguagefromStore();
    this.setLanguage(this.getLanguagefromStore());
  }

  public setLanguage(lang: string) {
    this.languageManagement(lang);
    // Wait until translations are loaded before notifying subscribers.
    // Otherwise the first RTL/AR switch keeps English labels (instant/CD runs too early).
    this.translate.use(lang).subscribe({
      next: () => this.currentLanguageSubject.next(lang),
      error: () => this.currentLanguageSubject.next(lang),
    });
  }

  languageManagement(lang: any) {
    if (lang === 'ar') {
      document.querySelector('html')?.setAttribute('dir', 'rtl');
      document.querySelector('html')?.setAttribute('lang', 'ar');

    }
    else {
      document.querySelector('html')?.setAttribute('dir', 'ltr');
      document.querySelector('html')?.setAttribute('lang', 'en');
    }
  }
  getLanguagefromStore(){
    const language = localStorage.getItem('lang');
    return (language && language !== 'undefined') ? language : 'en';
  }
 
  toggleLanguage() {
    let language = localStorage.getItem('lang') || 'en';
    let newLang = language === 'en' ? 'ar' : 'en';
    localStorage.setItem('lang', newLang);
    this.setLanguage(newLang);
    return newLang;
  }

}
